import { create } from 'zustand';

const STRIPED_ROWS_KEY = 'defaultStripedRows';
const SIDE_PANEL_OPEN_KEY = 'defaultSidePanelOpen';

interface UIPreferencesStore {
	stripedRows: boolean;
	setStripedRows: (value: boolean) => void;
	sidePanelOpen: boolean;
	setSidePanelOpen: (value: boolean) => void;
}

export const useUIPreferences = create<UIPreferencesStore>((set) => ({
	stripedRows: (() => {
		try {
			return JSON.parse(localStorage.getItem(STRIPED_ROWS_KEY) || 'false');
		} catch {
			return false;
		}
	})(),
	setStripedRows: (value: boolean) => {
		localStorage.setItem(STRIPED_ROWS_KEY, JSON.stringify(value));
		set({ stripedRows: value });
	},
	sidePanelOpen: (() => {
		try {
			return JSON.parse(localStorage.getItem(SIDE_PANEL_OPEN_KEY) || 'true');
		} catch {
			return true;
		}
	})(),
	setSidePanelOpen: (value: boolean) => {
		localStorage.setItem(SIDE_PANEL_OPEN_KEY, JSON.stringify(value));
		set({ sidePanelOpen: value });
	},
}));

export const getDefaultStripedRows = (): boolean => useUIPreferences.getState().stripedRows;
export const getDefaultSidePanelOpen = (): boolean => useUIPreferences.getState().sidePanelOpen;
